import { render } from "./ReferenceInfoAddition.vue?vue&type=template&id=5ff5155d&scoped=true"
import script from "./ReferenceInfoAddition.vue?vue&type=script&lang=js"
export * from "./ReferenceInfoAddition.vue?vue&type=script&lang=js"

import "./ReferenceInfoAddition.vue?vue&type=style&index=0&id=5ff5155d&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff5155d"]])

export default __exports__